import { POSTFORM, POST, GET } from '@/utils/request'
import Api from './url'
export const info = async (params: object) => {
  return await GET({ url: Api.info, params, showError: false })
}
export const createOrder = async (params: object) => {
  return await GET({ url: Api.createOrder, params, showError: false })
}
export const getRightsInfo = async (params: object) => {
  return await GET({ url: Api.getRightsInfo, params, showError: false })
}
export const detail = async (params: object) => {
  return await GET({ url: Api.detail, params, showError: false })
}
